module.exports = __webpack_public_path__ + "static/media/nadinala.6d58a318.png";